module.exports = __webpack_public_path__ + "static/media/hockey-mask.e2987c88.svg";